module.exports = __webpack_public_path__ + "img/logo-w.6b02dfbc.png";